angular.module('component-slider', ['ngTouch'])
	.directive('ctSlider', ['$window', '$timeout','$swipe', ctSliderDirective]);

function ctSliderDirective($window, $timeout,$swipe) {
	return {
		restrict: 'A',
		link: function (scope, element, attrs) {
			$(element[0]).slick({
				slidesToShow: 3,
				slidesToScroll: 1,
				arrows: true,
				infinite: false,
				speed: 300,
				accessibility: true,
				useTransform: true,
				responsive: [
					{
			  			breakpoint: 992,
				      	settings: {
				        	slidesToShow: 2
				      	}
				    },
					{
			      		breakpoint: 769,
				      	settings: {
				        	slidesToShow: 1
				      	}
			    	}
				]
			});
			
			$(element[0]).on('afterChange', function(event, slick, currentSlide) {
				$(this).find('.slick-dots button').attr('aria-selected', 'false');
				$(this).find('.slick-dots .slick-active button').attr('aria-selected', 'true');
				$(this).find('.slick-dots button').attr('tabindex', '0');
				
				var totalSlides = slick.slideCount;
				var currentSlideNumber = currentSlide + 1;
				var statusMessage = 'Слайд ' + currentSlideNumber + ' з ' + totalSlides;
				$(this).find('.slider-status').text(statusMessage);
			});
			
			setTimeout(function() {
				var $container = $(element[0]);
				var $dots = $container.find('.slick-dots');
				
				if ($dots.length) {
					$dots.attr('role', 'tablist').attr('aria-label', 'Навігація по слайдах');
					
					$dots.find('li').each(function(index) {
						var $li = $(this);
						var $button = $li.find('button');
						var isActive = $li.hasClass('slick-active');
						
						$li.removeAttr('role');
						
						$button.attr({
							'role': 'tab',
							'aria-selected': isActive ? 'true' : 'false',
							'aria-controls': 'slider-slide-' + index,
							'id': 'tab-slider-' + index
						});
						
						$button.removeAttr('aria-hidden');
						if ($button.attr('role') === 'button') {
							$button.removeAttr('role');
						}
						
						$button.attr('tabindex', '0');
					});
					
					$container.find('.slick-slide').each(function(index) {
						$(this).attr({
							'role': 'tabpanel',
							'aria-labelledby': 'tab-slider-' + index,
							'id': 'slider-slide-' + index
						});
					});
				}
				
				var prevButton = $container.find('.slick-prev');
				var nextButton = $container.find('.slick-next');
				if (prevButton.length) {
					prevButton.attr('aria-label', 'Попередній слайд');
					prevButton.removeAttr('role');
					prevButton.text('');
				}
				if (nextButton.length) {
					nextButton.attr('aria-label', 'Наступний слайд');
					nextButton.removeAttr('role');
					nextButton.text('');
				}
				
				$container.find('.slick-track[role="listbox"]').attr('role', 'region').attr('aria-label', 'Слайдер контенту');
				$container.find('.slick-slide[role="option"]').removeAttr('role');
				
				$container.removeAttr('aria-live');
				$container.find('[aria-live]').removeAttr('aria-live');
				
				if (!$container.find('.slider-status').length) {
					$container.append('<div class="slider-status" role="status" aria-live="polite" aria-atomic="true" style="position: absolute; left: -10000px; width: 1px; height: 1px; overflow: hidden;"></div>');
				}
				
				$container.find('.slick-dots button').attr('tabindex', '0');
				
				$container.find('[aria-hidden="true"] [tabindex="0"], [aria-hidden="true"] button, [aria-hidden="true"] a').attr('tabindex', '-1');
				
				setInterval(function() {
					$container.find('.slick-dots button[tabindex="-1"]').attr('tabindex', '0');
				}, 500);
				
				var totalSlides = $container.find('.slick-slide').length;
				if (totalSlides > 0) {
					$container.find('.slider-status').text('Слайд 1 з ' + totalSlides);
				}
			}, 100);
		}
	};
}



/*****************
 ** WEBPACK FOOTER
 ** ./app/components/slider/component-slider.js
 ** module id = 112
 ** module chunks = 1
 **/